
const seccis = document.querySelectorAll('.secci');



//let indexSeccionActiva;

// Observer
const observador = new IntersectionObserver((entras, observador) => {

	entras.forEach(entra => {
		if(entra.isIntersecting){
            entra.target.classList.add('visible');
			////console.log(entrada.isIntersecting);
            //const entry = entrada.target.id;


			// console.log(entry);
            //if (entry==="novedades"){
            //    //console.log("se hizo");
            //    //refs[2].classList.add('active');
            //}else {
            //    //console.log("no se hizo");
            //    //refs[2].classList.remove('active');
            //}
    
     
            
             
            };


            //refs.forEach(ref => {
            //   if(indexSeccionActiva===refs.[indexSeccionActiva]){} 
            //})
            
		
});
}, {
    root: null,
	rootMargin: '0px 0px 0px 0px',
	threshold: 0.1
    
});

// Agregamos un observador para el hero.
//observador.observe(document.getElementById('pagina'));

// Asignamos un observador a cada una de las secciones
seccis.forEach(secci => observador.observe(secci));

// Evento para cuando la pantalla cambie de tamaño.
